import { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import Image from 'components/Image';
import Footer from 'components/Footer';
import {
  ProjectContainer,
  ProjectBackground,
  ProjectHeader,
  ProjectSection,
  ProjectSectionContent,
  ProjectImage,
  ProjectSectionHeading,
  ProjectSectionText,
  ProjectSectionColumns,
  ProjectTextRow,
} from 'components/ProjectLayout';
import { useScrollRestore } from 'hooks';
import { media } from 'utils/style';
import prerender from 'utils/prerender';
import dttBackground from 'assets/dtt-background.jpg';
import dttBackgroundLarge from 'assets/dtt-background-large.jpg';
import dttBackgroundPlaceholder from 'assets/dtt-background-placeholder.jpg';
import dtt from 'assets/dtt.jpg';
import dttLarge from 'assets/dtt-large.jpg';
import dttPlaceholder from 'assets/dtt-placeholder.jpg';
import dttLanding from 'assets/dtt-landing.png';
import dttLandingLarge from 'assets/dtt-landing-large.png';
import dttLandingPlaceholder from 'assets/dtt-landing-placeholder.png';
import amazon from 'assets/amazon.png';
import amazonLarge from 'assets/amazon-large.png';
import amazonPlaceholder from 'assets/amazon-placeholder.png';
import amazon1 from 'assets/amazon1.png';
import amazon1Large from 'assets/amazon1-large.png';
import amazon1Placeholder from 'assets/amazon1-placeholder.png';
import amazon2 from 'assets/amazon2.png';
import amazon2Large from 'assets/amazon2-large.png';
import amazon2Placeholder from 'assets/amazon2-placeholder.png';


const title = 'Amazon';
const description =
  'I develop Amazon clone.';
const roles = ['Visual Identity', 'Full-stack Development', 'UX and UI Design'];

function DevTechTools() {
  useScrollRestore();

  return (
    <Fragment>
      <Helmet>
        <title>Projects | {title}</title>
        <meta name="description" content={description} />
      </Helmet>
      <ProjectContainer>
        <ProjectBackground
          srcSet={`${dttBackground} 1080w, ${dttBackgroundLarge} 2160w`}
          placeholder={dttBackgroundPlaceholder}
          entered={!prerender}
        />
        <ProjectHeader
          title={title}
          description={description}
          url="https://clone-akib.web.app/"
          roles={roles}
        />
        <ProjectSection first>
          <ProjectSectionContent>
            <ProjectImage
              raised
              srcSet={`${dtt} 1280w, ${dttLarge} 2560w`}
              placeholder={dttPlaceholder}
              sizes={`(max-width: ${media.mobile}px) 100vw, (max-width: ${media.tablet}px) 800px, 1000px`}
              alt="Landing screen of the DevTech Tools website."
            />
          </ProjectSectionContent>
        </ProjectSection>
        <ProjectSection>
          <ProjectSectionColumns>
            <ProjectTextRow>
              <ProjectSectionHeading>Visual Identity</ProjectSectionHeading>
              <ProjectSectionText>
                We represented the technology with a bundle of traces, accompanied with
                fresh colors and a crisp typeface.
              </ProjectSectionText>
            </ProjectTextRow>
            {/* <Image
              srcSet={`${dttBranding} 400w, ${dttBrandingLarge} 898w`}
              placeholder={dttBrandingPlaceholder}
              sizes={`(max-width: ${media.mobile}px) 100vw, (max-width: ${media.tablet}px) 100vw, 50vw`}
              alt="The DevTech Tools color palette and logo, featuring pipelines as electronic traces."
            /> */}
          </ProjectSectionColumns>
        </ProjectSection>

        <ProjectSection>
          <ProjectSectionContent>
            <ProjectTextRow>
              <ProjectSectionHeading>Amzon clone </ProjectSectionHeading>
              <ProjectSectionText>
                I developed the Amazon clone website, featuring a login function and add
                product and remove product & payement function also work but only in test
                version not in deployed if you want test version checkout my github page
              </ProjectSectionText>
            </ProjectTextRow>
            <Image
              srcSet={`${dttLanding} 1280w, ${dttLandingLarge} 2560w`}
              placeholder={dttLandingPlaceholder}
              alt="A screenshot of the landing page in production."
              sizes={`(max-width: ${media.mobile}px) 100vw, (max-width: ${media.tablet}px) 800px, 1000px`}
            />
            <Image
              srcSet={`${amazon} 1280w, ${amazonLarge} 2560w`}
              placeholder={amazonPlaceholder}
              alt="A screenshot of the landing page in production."
              sizes={`(max-width: ${media.mobile}px) 100vw, (max-width: ${media.tablet}px) 800px, 1000px`}
            />
            <Image
              srcSet={`${amazon1} 1280w, ${amazon1Large} 2560w`}
              placeholder={amazon1Placeholder}
              alt="A screenshot of the landing page in production."
              sizes={`(max-width: ${media.mobile}px) 100vw, (max-width: ${media.tablet}px) 800px, 1000px`}
            />
             <Image
              srcSet={`${amazon2} 1280w, ${amazon2Large} 2560w`}
              placeholder={amazon2Placeholder}
              alt="A screenshot of the landing page in production."
              sizes={`(max-width: ${media.mobile}px) 100vw, (max-width: ${media.tablet}px) 800px, 1000px`}
            />
          </ProjectSectionContent>
        </ProjectSection>
      </ProjectContainer>
      <Footer />
    </Fragment>
  );
}

export default DevTechTools;
